import React from "react";
import XLSX from "xlsx";
import { Button } from "antd";
import api from "../../services/api";
import { refresh_token } from "./services/refresh_token";
import { data_venda } from "./services/venda";
import NotaFiscalTableRow from "./components/nota_fiscal";

export default class ContaAzul extends React.Component {
  componentDidMount = async () => {
    /*Busca os token do conta azul*/
    this.setState({ ...this.state });
  };

  state = {
    upado: false
  };

  handleChange = e => {
    const files = e.target.files;
    if (files && files[0]) this.setState({ ...this.state, file: files[0] });
  };

  make_cols = refstr => {
    let o = [],
      C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i)
      o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
  };

  handleFile = () => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = e => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws);
      /* Update state */
      let linhas = [];
      this.setState({
        ...this.state,
        data: data,
        cols: this.make_cols(ws["!ref"]),
        upado: true
      });
      //this.getParcelas()
    };
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  };

  getParcelas = async () => {
    let i = 0;
    for (i = 0; i < this.state.data.length; i++) {
      const numero_nf = this.state.data[i]["Nr. Nota Fiscal"];
      const res = await api.get(`/parcela/?notafiscal__numero_nf=${numero_nf}`);
      if (res.data.results.length > 0) {
        const parcela = res.data.results[0];
      }
    }
  };

  render() {
    if (this.state.upado == true) {
      let tr = [];
      for (let i = 0; i < this.state.data.length; i++) {
        tr.push(<NotaFiscalTableRow pagamento={this.state.data[i]} />);
      }
      return (
        <React.Fragment>
          <br></br>
          <table className="acordoview__table">
            <thead>
              <tr>
                <th>Nota Fiscal</th>
                <th>Pasta</th>
                <th>Tipo de Acordo</th>
                <th>Nº Parcela</th>
                <th>Valor Parcela</th>
                <th>Valor Pago</th>
                <th>Data Vencimento</th>
                <th>Data Pagamento</th>
                <th>Status Parcela</th>
                <th>Status</th>
                <th>Motivo</th>
              </tr>
            </thead>
            <tbody>{tr}</tbody>
          </table>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <br />
        <div className="div__input">
          Importar planilha de pagamento de nota fiscal da HDI.
          <br />
          <br />
          Notas que já foram enviadas pro conta azul não serão enviadas
          novamente.
          <br />
          <br />
          <input
            type="file"
            className="ant-input"
            style={{ width: "30%" }}
            id="file"
            onChange={this.handleChange}
          />
          <br />
          <div className="cw__inputs">
            <Button type="primary" onClick={this.handleFile}>
              Upload
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ContaAzul/index.js